import _classCallCheck from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { QualifierModel } from "../../internal/models/QualifierModel.js";
/**
 * @memberOf Qualifiers.Source
 * @extends {QualifierModel}
 * @description An abstract class extended by all Source objects
 */

var BaseSource = /*#__PURE__*/function (_QualifierModel) {
  _inherits(BaseSource, _QualifierModel);

  var _super = _createSuper(BaseSource);

  function BaseSource() {
    _classCallCheck(this, BaseSource);

    return _super.apply(this, arguments);
  }

  _createClass(BaseSource, [{
    key: "encodeAssetPublicID",
    value:
    /**
     * @description Utility function to encode an asset publicID in an overlay
     * @protected
     * @example
     * encodeAssetPublicID('foo/bar'); // -> foo:bar
     */
    function encodeAssetPublicID(publicID) {
      return publicID.replace(/\//g, ':');
    }
    /**
     * @description
     * Apply a transformation on the image source of the layer
     * @param {SDK.ImageTransformation} t An image transformation to apply to the layer
     * @returns {this}
     */

  }, {
    key: "transformation",
    value: function transformation(t) {
      this._qualifierModel.transformation = t.toJson();
      this._transformation = t;
      return this;
    }
    /**
     * @description Returns the Transformation of the source
     * @return {SDK.Transformation}
     */

  }, {
    key: "getTransformation",
    value: function getTransformation() {
      return this._transformation;
    }
  }]);

  return BaseSource;
}(QualifierModel);

export { BaseSource };